import React from 'react';
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';

export interface CollapsibleTableProps {
  tableData: any[];
  tableHeaders: React.JSX.Element;
  tableRows: any;
  width?: string;
  headerHeight?: string;
}

const CollapsibleTable: React.FC<CollapsibleTableProps> = ({
  tableData,
  tableHeaders,
  tableRows,
  width,
  headerHeight,
}) => {
  const { classes } = makeStyles()({
    root: {
      width: width ?? '1182px',
      borderRadius: '4px',
    },
    tableHeader: {
      backgroundColor: patientAccessTheme.palette.grey[400],
      border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      height: headerHeight ?? '48px',
      '& .MuiTableCell-head': {
        fontSize: '12px',
        lineHeight: '12px',
        fontWeight: 500,
        color: patientAccessTheme.palette.text.highemphasis,
      },
    },
  })();

  return (
    <TableContainer className={classes.root}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow className={classes.tableHeader}>{tableHeaders}</TableRow>
        </TableHead>
        <TableBody>
          {tableData?.map((row: any, index: number) => {
            return tableRows(row, index);
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CollapsibleTable;
